import { createReducer } from 'pobble-components/dist/redux-helpers'

let defaultState = {
  ids: [],
  opened: false
}

const SetVisibilityDialog = createReducer(defaultState, {
  'GROUPS:SET_VISIBILITY_DIALOG:OPEN': (state, { ids }) => ({
    ...state,
    opened: true,
    ids
  }),
  'GROUPS:SET_VISIBILITY_DIALOG:CLOSE': state => ({ ...defaultState }),
  'GROUPS_STORE:UPDATE_REQUEST': state => ({ ...defaultState })
})

export default SetVisibilityDialog
